// ** Redux Imports
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

// ** Axios Imports
import API from 'api/orders'

export const list = createAsyncThunk('appOrderDiscountTypes/list', async () => {
  return await API.listOrderDiscountTypes()
})

export const get = createAsyncThunk('appOrderDiscountTypes/get', async name => {
  return await API.getOrderDiscountType(name)
})

export const add = createAsyncThunk('appOrderDiscountTypes/add', async (instance, { dispatch }) => {
  const updated = await API.createOrderDiscountType(instance)
  instance = {
    ...instance,
    updated
  }
  await dispatch(list())
  return instance
})

export const modify = createAsyncThunk('appOrderDiscountTypes/modify', async (instance, { dispatch }) => {
  const updated = await API.updateOrderDiscountType(instance)
  instance = {
    ...instance,
    updated
  }
  await dispatch(appOrderDiscountTypesSlice.actions.setSelected(instance))
  await dispatch(list())
})

export const del = createAsyncThunk('appOrderDiscountTypes/del', async (name, { dispatch }) => {
  await API.deleteOrderDiscountType(name)
  await dispatch(list())
  return name
})

export const appOrderDiscountTypesSlice = createSlice({
  name: 'appOrderDiscountTypes',
  initialState: {
    data: [],
    selected: null
  },
  reducers: {
    setSelected: (state, { payload }) => {
      state.selected = payload
    }
  },  extraReducers: builder => {
    builder
      .addCase(list.fulfilled, (state, action) => {
        state.data = action.payload
      })
      .addCase(get.fulfilled, (state, { payload }) => {
        state.selected = payload
      })
  }
})

export default appOrderDiscountTypesSlice.reducer
